import { useCallback, useState, useEffect } from "react";
import cx from "classnames";
import Picture from "./picture";

const chunk = (array, size = 2) => {
  const list = [];
  if (array?.length > 0) {
    for (let i = 0; i < array.length; i += size) {
      const chunk = array.slice(i, i + size);
      list.push(chunk);
    }
  }
  return list;
};

const GalleryMixedGrid = ({ photos, activePhoto, parentNode, onClick = () => undefined }) => {
  const [chunks, setChunks] = useState([]);

  useEffect(() => {
    setChunks(chunk(photos));
  }, [photos]);

  const ref = useCallback(
    (node) => {
      if (node && parentNode && activePhoto) {
        setTimeout(() => {
          const ele = node.querySelector(`[data-gallery-img-id="${activePhoto._id}"]`);
          const rect = ele && ele.getBoundingClientRect();
          if (rect) {
            parentNode.scrollTo({ top: rect.y - 60, behavior: "smooth" }); // subtract header height
          }
        }, 400); // wait for keyframe animations to end
      }
    },
    [parentNode, activePhoto]
  );

  if (!chunks.length) return null;

  return chunks.map((chunk) => {
    const size = chunk.length === 1 ? 600 : 420;
    return (
      <div
        ref={ref}
        key={chunk.map((p) => p._id).join("-")}
        className={cx(
          "mb-2 grid gap-2",
          chunk.length === 2 && "auto-rows-[33vw] grid-cols-2 md:auto-rows-[22vw] 2xl:auto-rows-[17vw]",
          chunk.length === 1 && "auto-rows-[44vw] grid-cols-1 md:auto-rows-[33vw] 2xl:auto-rows-[25vw]"
        )}
      >
        {chunk.map((photo) => (
          <Picture
            key={photo?._id}
            width={size}
            height={size}
            picture={photo}
            layout="intrinsic"
            objectFit="cover"
            alt={photo?.alt}
            title={photo?.alt}
            onClick={() => onClick(photo)}
            className="cursor-pointer md:rounded-sm"
            data-gallery-img-id={photo._id}
          />
        ))}
      </div>
    );
  });
};

export default GalleryMixedGrid;
